import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  templateUrl: './home-ward-lookup.component.html',
  styleUrls: ['./home-ward-lookup.component.scss']
})
export class HomeWardLookupComponent implements OnInit {
  iNumber: string;
  email: string;

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    // pull the value from our URL if it's there
    if (this.route.firstChild) {
      const identifier = this.route.firstChild.snapshot.paramMap.get(
        'identifier'
      );
      const iNumberMatch = identifier.match(/^\d+$/);
      if (iNumberMatch) {
        this.iNumber = identifier;
      } else {
        this.email = identifier;
      }
    }
  }

  navigateToLoad(): void {
    // if we have an I-Number use that as our identifier; otherwise use the email address
    // remove any whitespace too; shouldn't have it
    let identifier = this.email; // I-Number always trumps
    if (this.iNumber) {
      identifier = this.iNumber;
    }
    identifier = identifier.replace(/\s/g, '');

    this.router.navigate(['./', identifier], { relativeTo: this.route });
  }
}
